import React from "react"
import SbEditable from "storyblok-react"

import { Textarea } from "gatsby-theme-gba"

const TextareaEditable = ({ blok }) => (
  <SbEditable content={blok}>
    <Textarea
      name={blok.name}
      label={blok.label}
      value={blok.value}
      placeholder={blok.placeholder}
      required={blok.required}
    />
  </SbEditable>
)

export default TextareaEditable
